module.exports = __webpack_public_path__ + "img/icon_whatsapp.68c54461.png";